/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxRateKey
 */
export interface FxRateKey {
    /**
     * 
     * @type {string}
     * @memberof FxRateKey
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxRateKey
     */
    portfolio?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxRateKey
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof FxRateKey
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxRateKey
     */
    description?: string | null;
}

/**
 * Check if a given object implements the FxRateKey interface.
 */
export function instanceOfFxRateKey(value: object): value is FxRateKey {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function FxRateKeyFromJSON(json: any): FxRateKey {
    return FxRateKeyFromJSONTyped(json, false);
}

export function FxRateKeyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxRateKey {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'portfolio': json['portfolio'] == null ? undefined : json['portfolio'],
        'key': json['key'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function FxRateKeyToJSON(json: any): FxRateKey {
    return FxRateKeyToJSONTyped(json, false);
}

export function FxRateKeyToJSONTyped(value?: FxRateKey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'portfolio': value['portfolio'],
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
    };
}

